<template>
    <Dialog style="padding:50px" :value="value" @input="$listeners.input" :unlimit-height="true" title="Ajustar Email" :show-close-button="true" width="500">
        <div class="description">
            <p class="description-text">
                Editar o e-mail fará a ação de cancelar o contrato para assinatura atual e criar um novo contrato! <br> O cliente receberá automaticamente o novo contrato no e-mail ajustado.
            </p>

            <span class="old-email-label">
                Email atual:
            </span>

            <p class="old-email">{{ oldEmail }}</p>
            <m-form ref="change_email_form" class="pt-2 text-right" @submit.prevent="mudarEmail">
                <m-text-field ref="input"
                              id="fieldEmail"
                              label="Novo e-mail:"
                              class="required"
                              v-model="email"
                              v-input-filter="[$filters.email]"
                              autocomplete="off"
                              :rules="[$rules.required, $rules.email, verifyEmailEqualsLoggedUser]"
                              maxlength="100"
                              outlined />
                <m-text-field ref="input"
                              id="fieldEmailConfirm"
                              label="Confirmar novo e-mail:"
                              class="required less-margin"
                              v-model="confirm_email"
                              v-input-filter="[$filters.email]"
                              :rules="[$rules.required, $rules.email,verificaEmailIgual]"
                              maxlength="100"
                              outlined
                              autocomplete="off"
                              onpaste="return false;" />
                <v-btn color="primary" @click="changeCustomerEmailAndResendEmails">Confirmar</v-btn>
            </m-form>
        </div>
    </Dialog>
</template>
<script>

  import { notification } from '../plugins/helpers'
  import { AlertTypes } from '../plugins/alerts_types'

  export default {
    name: 'DialogChangeEmail',
    props: { value: Boolean, oldEmail: String, pedido: Object },
    data () {
      return {
        email: '',
        confirm_email: ''
      }
    },
    watch: {
      value (newValue) {
        if (newValue) {
          this.$refs.change_email_form.resetValidation()
          this.email = ''
          this.confirm_email = ''
        }
      }
    },
    methods: {
      async changeCustomerEmailAndResendEmails () {
        if (this.$refs.change_email_form.validate()) {
          return this.$http.post('/proposta/change_mail_and_resend', {
            'id_person_erp': this.pedido.cliente.id_pessoa_erp,
            'id_pedido': this.pedido.id_pedido,
            'new_email': this.email
          }).then(response => {
            this.$emit('change_email_outside', this.email)
            this.$emit('close')
            notification(AlertTypes.INFO, response.data.Msg)
          }).catch(err => {
            this.$emit('close')
            notification(AlertTypes.ERROR, err.response.data.Msg ?? 'Falha para atualizar o e-mail. Tente novamente mais tarde!')
          })
        }
      },
      verifyEmailEqualsLoggedUser () {
        const loggedUserData = this.$session.get('dados_usuario_logado')
        const id_logged_user = loggedUserData.id_pessoa_newcon
        const email_logged_user = loggedUserData.email_pessoa

        if (!id_logged_user || !email_logged_user || id_logged_user === this.pedido.cliente.id_pessoa_erp) {
          return true
        }
        if (email_logged_user.toUpperCase() === this.email.toUpperCase()) {
          return 'E-mail não pode ser o mesmo do usuário logado.'
        }
        return true
      },
      verificaEmailIgual () {
        if (this.email !== this.confirm_email || this.email === '') {
          return 'E-mails não coincidem!'
        }
        return true
      }
    }
  }
</script>

<style scoped>

.description{
  padding: 0 2rem;
}
.description-text{
  color:var(--primary);
  text-align: justify;
  font-size: 1rem;
}
.old-email-label{
  color:var(--neutral);
}
.old-email{
  margin: 0.5rem 0 0rem 1rem;
}
.less-margin{
  margin-top: 2rem;
}

</style>
